import axios from "axios";

const postApiService = async (baseUrl, targetUrl, data, headers = {}) =>{

    try{
        const postApi = axios.create({
            baseURL: baseUrl,
            headers: headers
        });
    
        return await postApi.post(targetUrl,data);

    }catch(error){
        if (error.code === "ECONNABORTED") {
            console.log("Request timed out !");
          } else {
            console.log("An error occurred: ", error);
          }
    }
};

const getApiService = async (baseUrl, targetUrl, data, headers = {}) => {
    
    try{
        const getApi = axios.create({
            baseURL: baseUrl,
            headers: headers
        });
    
        return await getApi.get(targetUrl,{
            params: data,
            timeout: 50000
        });

    }catch(error){
        if (error.code === "ECONNABORTED") {
            console.log("Request timed out !");
          } else {
            console.log("An error occurred: ", error);
          }
    }
};

export { getApiService, postApiService };